
import axios from 'axios';
import { DOMAIN,FUNC_EXEC_MYSQL_URL } from '../globals/constants';

export const callFunc = (params) => {

    return new Promise((resolve,reject) => {

        axios.post(FUNC_EXEC_MYSQL_URL, params).then((response) => {
            const data = response.data;
            console.log("func call data is",data)
            if( data.code === 200 ) {
                resolve(data.result)
            } else {
                reject(data)
            }
          });
    })
}

const getDomain = () => {
  let domain = ""
  if(process.env.NODE_ENV == "development") {
    domain = DOMAIN
  } else {
    domain = document.domain
    console.log("生产环境domain is", domain)
  }

  return domain
}

export const getLayoutInfo = () => {
    
    const sql = `SELECT fa_web_base_info.*, fa_web_footer_base_info.company_name,fa_web_color.theme_color, 
                fa_web_color.topmenu_background_color,fa_web_color.topmenu_dropdown_color, fa_web_color.topmenu_font_color,fa_web_color.topmenu_font_hover_color 
                  FROM fa_web_base_info 
                  LEFT JOIN fa_web_footer_base_info 
                  ON fa_web_base_info.shop_id = fa_web_footer_base_info.shop_id
                  LEFT JOIN fa_web_color 
                  ON fa_web_color.shop_id = fa_web_base_info.shop_id
                  WHERE fa_web_base_info.domain = "${getDomain()}"`
    console.log("getLayoutInfo is", sql)
    const params = {
        sql
    }

    return callFunc(params)
}

export const getContactNumber = () => {
    const params = {
        sql: `SELECT contact_number
                FROM fa_web_base_info
                WHERE domain = "${getDomain()}"`       
    }
    return callFunc(params)
}

export const getTopmenuCategoryList =  () => {
  const params = {
      sql: `SELECT m.* 
            FROM fa_web_topmenu_category AS m
            LEFT JOIN  fa_web_base_info AS b ON b.shop_id = m.shop_id
            WHERE b.domain = "${getDomain()}" AND m.delete_time = 0
            ORDER BY m.id ASC
            `       
  }

  return callFunc(params)
 
}



export const getPortalPage = () => {
  const sql = `SELECT fa_page.* , fa_web_color.theme_color
          FROM fa_page 
          LEFT JOIN fa_web_base_info 
          ON fa_web_base_info.shop_id = fa_page.shop_id
          LEFT JOIN fa_web_color
          ON fa_web_color.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_page.is_website_home = 1`
  
  const params = {
    sql
  }

  return callFunc(params)
}

export const getAboutusPage = () => {
  const sql = `SELECT fa_page.* , fa_web_color.theme_color
          FROM fa_page 
          LEFT JOIN fa_web_base_info 
          ON fa_web_base_info.shop_id = fa_page.shop_id
          LEFT JOIN fa_web_color
          ON fa_web_color.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_page.is_website_aboutus = 1`
  
  const params = {
    sql
  }

  return callFunc(params)
}

export const getServicePage = () => {
  const sql = `SELECT fa_page.* , fa_web_color.theme_color
          FROM fa_page 
          LEFT JOIN fa_web_base_info 
          ON fa_web_base_info.shop_id = fa_page.shop_id
          LEFT JOIN fa_web_color
          ON fa_web_color.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_page.is_website_service = 1`
  
  const params = {
    sql
  }

  return callFunc(params)
}

export const getBreadcrumbList = () => {
    const params = {
      
        sql: `SELECT c.*
                FROM  fa_web_breadcrumbs AS c
                LEFT JOIN  fa_web_base_info AS b ON b.shop_id = c.shop_id
                WHERE b.domain = "${getDomain()}" AND c.delete_time = 0`      
    }

    return callFunc(params)
}

export const getPageInfo = (id) => {
  const sql = `SELECT fa_page.* , fa_web_color.theme_color
          FROM fa_page 
          LEFT JOIN fa_web_base_info 
          ON fa_web_base_info.shop_id = fa_page.shop_id
          LEFT JOIN fa_web_color
          ON fa_web_color.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_page.id = ${id}`
  
  const params = {
    sql
  }

  return callFunc(params)
}

export const getGoodsList = (page, limit = 10) => {
  const sql = `SELECT fa_goods.*
          FROM fa_goods
          LEFT JOIN fa_web_base_info 
          ON fa_goods.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}"
          LIMIT ${limit}
          `

  const params = {
    sql
  }

  return callFunc(params)
}

export const getGoodInfo = (id) => {
  const sql = `SELECT fa_goods.*
          FROM fa_goods
          LEFT JOIN fa_web_base_info 
          ON fa_goods.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_goods.id = ${id}`
  
  const params = {
    sql
  }

  return callFunc(params)
}

export const getGoodCategoryList = (category_ids) => {
  const sql = `SELECT fa_goods_category.*
          FROM fa_goods_category
          LEFT JOIN fa_web_base_info 
          ON fa_goods_category.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_goods_category.id IN (${category_ids})`
  
  const params = {
    sql
  }

  return callFunc(params)
}

export const getPriceCategoryList = (category_ids) => {
   console.log('197 sql category ids ', category_ids)

   const sql = `SELECT fa_web_price_category.*, fa_web_price.*
          FROM fa_web_price_category
          LEFT JOIN fa_web_price 
          ON fa_web_price.shop_id = fa_web_price_category.shop_id
          LEFT JOIN fa_web_base_info 
          ON fa_web_price_category.shop_id = fa_web_base_info.shop_id 
          WHERE fa_web_base_info.domain = "${getDomain()}" AND fa_web_price_category.id IN (${category_ids})`
   const params = {
      sql
   }

   return callFunc(params)
}
